export default __webpack_public_path__ + "static/media/product-manager.60ffb186.jpg";